import React, { useState, useEffect } from 'react';
import { isFunction, isEmpty } from 'lodash';
import get from 'lodash/get';
import classNames from 'classnames';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { Icon } from 'ui';
import { OwnerContext } from './OwnerContext';
import { canEditAndViewActivity } from './permission';

const OwnersListItem = ({ owner, children, ownershipType }) => {
  const ownerships = get(owner, 'ownerships', false);
  const [paths, setPaths] = useState({});
  const [showPaths, setShowPaths] = useState(false);

  const togglePaths = () => {
    setShowPaths(!showPaths);
  };

  useEffect(() => {
    if (ownerships && showPaths && isEmpty(paths)) {
      ownerships.forEach(ownership => {
        if (ownership.ownable_type === 'LearningPaths::Path')
          request.get(routes.PATH_VIEW(ownership.ownable_id)).then(response => {
            const newPath = {
              title: response.title,
              id: response.id,
            };
            setPaths(oldPaths => ({ ...oldPaths, [newPath.id]: newPath }));
          });
      });
    }
  }, [ownerships, setPaths, showPaths, paths]);

  return (
    <OwnerContext.Provider value={owner}>
      <div className="user owner quicklist-item jc-sb">
        <div className="d-f fd-c">
          {ownershipType === t('ownership.heading.automatic_owners') && (
            <>{owner.name}</>
          )}
          {ownershipType === t('ownership.heading.inherited_owners') && (
            <>
              <div
                className={classNames(
                  !showPaths && 'collapsed',
                  ownerships && 'Accordion-headingWrapper w-fill',
                )}
              >
                {owner.name}
                <Icon
                  name="expand"
                  className={classNames('Accordion-icon mt-0-imp h-cr-p')}
                  onClick={togglePaths}
                />
              </div>
              <div
                className={classNames(
                  'mt-10 d-f fd-c',
                  !showPaths && 'vis-hid',
                )}
              >
                {showPaths &&
                  Object.values(paths).map(path => (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      key={path.id}
                      href={routes.PATH_VIEW(path.id)}
                    >
                      <Icon name="path" className="mr-4 h-cr-p" /> {path.title}
                    </a>
                  ))}
              </div>
            </>
          )}
        </div>
        <div className="f-d fd-r">
          {ownershipType === t('ownership.heading.shared_owners') && (
            <>
              {owner.type === 'Group' ? (
                <Icon name="group" className="mr-8 c-brand-gray-dark" />
              ) : null}
              {owner.name}
            </>
          )}
          {canEditAndViewActivity(owner) && (
            <span
              className="Role"
              data-toggle="tooltip"
              title={t('ownership.reporting_permissions.lessons.description')}
            >
              {t('ownership.reporting_permissions.badge')}
            </span>
          )}
          {isFunction(children) ? children(owner) : children}
        </div>
      </div>
    </OwnerContext.Provider>
  );
};

export default OwnersListItem;
